import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["notice", "alert"];
  static values = {
    duration: { type: Number, default: 5000 },
  };

  connect() {
    // Start the auto-dismiss timer
    this.startTimer();
  }

  startTimer() {
    this.timeout = setTimeout(() => {
      this.dismiss();
    }, this.durationValue);
  }

  dismiss() {
    // Add fade-out class
    this.element.classList.add("opacity-0", "transform", "translate-y-2");

    // Remove the element after animation completes
    setTimeout(() => {
      this.element.remove();
    }, 300); // Match the transition duration
  }

  // Pause the timer when hovering over the notification
  pauseTimer() {
    clearTimeout(this.timeout);
  }

  // Resume the timer when mouse leaves
  resumeTimer() {
    this.startTimer();
  }

  // Manually dismiss the notification
  close() {
    this.dismiss();
  }
}
